


























import Vue from 'vue'

import { QAQC, FindQAQC } from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      qaqcId: 0,
      QAQCs: [] as QAQC[],
    }
  },

  methods: {
    async findQAQC() {
      this.QAQCs = await FindQAQC()
    },

    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------
    onRowClick(qaqc: QAQC) {
      this.$router.push({
        path: `/cems/setting/qaqc/${qaqc.id}`,
      })
    },
  },

  async created() {
    this.qaqcId = parseInt(this.$route.params.qaqcId)
    await this.findQAQC()
  },
})
